<template>
  <div>
    <router-view />
    <Footer v-if="!isVideo" />
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  components: {
    Footer,
  },
  computed: {
    isVideo: function () {
      return this.$store.getters["getIsVideo"];
    },
  },
  watch: {
    $route(to, from) {
      if (from.name && to.name != from.name && to.name == "Antiquity") {
        this.$router.go();
      }
    },
  },
  mounted() {
    if (this.$store.getters.getLocale) {
      this.$i18n.locale = this.$store.getters.getLocale.code;
    } else {
      this.$i18n.locale = "ko";
    }
  },
};
</script>
